import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import App from "./pages/App";
import store from "./redux/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ModalProvider } from "styled-react-modal";
import { CustomModalBackground, GlobalStyle } from "./global-styles";
import defaultTheme from "./global-themes";
import "./global-icons";
import "react-toastify/dist/ReactToastify.css";
import "lightgallery.js/dist/css/lightgallery.css";
import { LightgalleryProvider } from "react-lightgallery";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "services/azureService";

const pca = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <MsalProvider instance={pca}>
    <Provider store={store}>
      <ThemeProvider theme={defaultTheme}>
        <ModalProvider backgroundComponent={CustomModalBackground} >
          <LightgalleryProvider>
            <Fragment>
              <App />
              <GlobalStyle />
            </Fragment>
          </LightgalleryProvider>
        </ModalProvider>
      </ThemeProvider>
    </Provider>
  </MsalProvider>,
  document.getElementById("root")
);
